export default __webpack_public_path__ + "static/InterDisplay-ExtraLight-5076a4daf0bd19a993fc377d04504745.woff";